import { RequestForm } from "@/components/request-form";

/** Raise a payment request. (The "New request" title comes from the shell's app bar.) */
export default function NewRequest() {
  return <RequestForm mode="new" />;
}
